"use strict";
exports.__esModule = true;
var so_rich_text_box_component_1 = require("../../../../../../components/so-rich-text-box/so-rich-text-box.component");
angular.module('smartorg.r6.acts.smartText', [
    'angular-rich-text-diff',
    so_rich_text_box_component_1["default"],
]);
require('./smart-text-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.acts.smartText';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/smart-text/app/js/plumbing/app.js